import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NSCard } from 'bricks';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import React from 'react';
import { Row } from 'reactstrap';
import './KeyStatsCardWithIcon.scss';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface IKeyStatsCardWithIconProps {
    title: string;
    value: number | string;
    icon: IconDefinition;
    isPercentage?: boolean;
    cardClassname?: string;
}

const KeyStatsCardWithIcon = ({
    title, value, isPercentage, icon, cardClassname,
}: IKeyStatsCardWithIconProps) => {
    const format = isPercentage ? '0,0.00%' : '$0,0.00';

    return (
        <NSCard className={`KeyStatsCardWithIcon py-3 px-3 ${cardClassname || ''}`}>
            <FontAwesomeIcon icon={icon} className="text-primary KeyStatsCardWithIcon__bg-icon" />
            <Row className="mx-0 d-flex justify-content-between" style={{ width: 'inherit' }}>
                <div className="d-flex align-items-center">
                    <span className="mr-1">{title}</span>
                </div>
            </Row>
            <Row className="mx-0 mb-0">
                <h3 className="text-dark font-weight-bold mt-1">
                    {typeof value === 'number' && numeralFormatterCurrency(value, format)}
                    {typeof value === 'string' && value}
                </h3>
            </Row>
        </NSCard>
    );
};

export default KeyStatsCardWithIcon;
